import { css } from 'lit';
import { IxIcon } from './IxIcon.js';

export class IxIconStyled extends IxIcon {
  static override styles = css`
    :host {
      font-size: var(--ix-icon-font-size);
      height: var(--ix-icon-font-size);
      line-height: var(--ix-icon-line-height);
      width: var(--ix-icon-font-size);
    }

    md-icon {
      font-size: var(--ix-icon-font-size);
      height: var(--ix-icon-font-size);
      line-height: var(--ix-icon-line-height);
      width: var(--ix-icon-font-size);
    }

    md-icon[filled] {
      font-variation-settings: 'FILL' 1;
    }
  `;
}

customElements.define('ix-icon', IxIconStyled);
